import {
  IGetAllProjectsResponseModel,
  IGetProjectRequestModel,
  IGetProjectResponseModel,
} from "@lib/types";

export const projects = new Array<IGetAllProjectsResponseModel>(
  {
    id: 1001,
    order_number: "ORD-123",
    description: "custom description",
    audiences: 0,
  },
  {
    id: 1002,
    order_number: "ORD-456",
    description: "custom description",
    audiences: 0,
  },
  {
    id: 1003,
    order_number: "ORD-678",
    description: "custom description",
    audiences: 0,
  },
  {
    id: 1004,
    order_number: "ORD-91011",
    description: "custom description",
    audiences: 0,
  },
  {
    id: 1005,
    order_number: "ORD-121314",
    description: "custom description",
    audiences: 0,
  },
);

export const project: IGetProjectResponseModel = {
  id: 1001,
  order_number: "ORD-123",
  description: "custom description",
  audiences: [
    {
      context_id: "e3b73fef-7fb8-4144-83ce-af1236f1fc23",
      description: "custom audience description",
      country: "US",
      language: "en",
    },
  ],
};
